import * as React from 'react'
import NotFoundIllustration from 'assets/icons/not-found.svg'
import styles from './index.module.css'

type Props = {
  title?: React.ReactNode
  subtitle?: React.ReactNode
  body?: React.ReactNode
}

export default function NotFoundPage({
  title = 'Oops! Page not found',
  subtitle = "We can't find the page you're looking for.",
  body = (
    <>
      If someone sent you a playlist or track link, ask them to resend it - it
      might have moved. Still stuck? Hit up{' '}
      <a
        href="mailto:support@disco.ac"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
      >
        support@disco.ac
      </a>
      <span className={styles.linkPeriod}>.</span>
    </>
  ),
}: Props): React.ReactElement {
  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <NotFoundIllustration className={styles.illustration} />
        <div className={styles.textBlock}>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.subtitle}>{subtitle}</p>
          <p className={styles.body}>{body}</p>
        </div>
      </div>
    </div>
  )
}
